export const deleteSellerInfo = (state) => {
  const next = {...state};
  delete next["sellerInfo"];
  return next;
}
